// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Box, Button, Heading } from 'grommet';
import { GrommetForm, Modal } from 'speed-js-react-web';
import type { Form } from 'esm-web-pro/redux/workflow/form';
import { removeForm } from 'esm-web-pro/redux/workflow/form';

type Props = Form & {
    workflowCode: string;
    executionId: string,
    resumeFlow: Function,
    schema: ?Object,
    workflowManager: Object,
    removeForm: (code: string, executionId: string) => void,
    code: string,
    setLoading: Function,
};

@connect(null, (dispatch) => (bindActionCreators({ removeForm }, dispatch)))
class WorkflowModalForm extends React.Component<Props> {
    handleSubmit = (values: Object, formik: Object) => {
        const {
            resumeFlow, executionId, requestKey, removeForm: removeFormAction, code, setLoading,
        } = this.props;

        setLoading(true);
        if (!this.registeredHandler) {
            const { workflowManager } = this.props;

            workflowManager.addActionHandler(
                executionId, 'set_validation_errors',
                (data: { executionId: string, errors: Object }) => {
                    formik.setSubmitting(false);
                    formik.setErrors(data.errors);
                }, true,
            );

            this.registeredHandler = true;
        }

        resumeFlow(executionId, requestKey ? { [requestKey]: values } : values).then(() => {
            setLoading(false);
            formik.setSubmitting(false);
            removeFormAction(code, executionId);
        });
    };

    renderActions = ({ isSubmitting }: { isSubmitting: boolean }) => {
        const { buttonLabel } = this.props;

        return (
            <Box dirextion="row" margin={{ vertical: 'small' }}>
                <Button label={buttonLabel} type="submit" alignSelf="end" disabled={isSubmitting} />
            </Box>
        );
    };

    handleClose = () => {
        const {
            onClose, removeForm: removeFormAction, code, executionId, resumeFlow,
        } = this.props;

        resumeFlow(executionId);

        removeFormAction(code, executionId);

        if (onClose) {
            onClose();
        }
    };

    render() {
        const {
            schema, title, requestKey, initialData,
        } = this.props;

        if (!schema) return null;

        return (
            <Modal
                onClose={this.handleClose}
                opened
                size="large"
            >
                <Modal.Header>
                    <Box flex align="center">
                        <Heading level={2} textAlign="center">{title}</Heading>
                    </Box>
                </Modal.Header>
                <Modal.Content>
                    <GrommetForm
                        schema={schema}
                        onSubmit={this.handleSubmit}
                        actions={this.renderActions}
                        initial={initialData}
                        key={requestKey}
                    />
                </Modal.Content>
            </Modal>
        );
    }
}

export default WorkflowModalForm;
